import React, { Component } from 'react'
import './MyReceipts.scss'
import { pullAndSetReceiptDetails, setReceiptsError } from './MyReceiptsActions'
import { connect } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'

class MyReceiptDetails extends Component {
  componentDidMount() {
    if (!this.props.selectedReceipt) {
      setReceiptsError({ message: 'Could not find selected receipt item.', code: null })
      return
    }

    if (this.props.selectedReceipt) {
      this.getDetails(this.props.selectedReceipt)
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.selectedReceipt) return

    try {
      if (prevProps.selectedReceipt.REF_NUM != this.props.selectedReceipt.REF_NUM) {
        this.getDetails(this.props.selectedReceipt)
      }
    } catch (error) {
      setReceiptsError({ message: 'Could not find selected receipt item.', code: null })
      return
    }
  }

  getDetails(selectedReceipt) {
    if (selectedReceipt) {
      this.props.pullAndSetReceiptDetails(selectedReceipt.RECEIPT_ID)
    }
  }

  renderDetailList = (detailList) => {
    if (this.props.myReceiptDetailsLoading) {
      return (
        <div className="reports-spinner animated fadeIn">
          <Spinner size="medium" themeColor="secondary" />
        </div>
      )
    }

    if (this.props.myReceiptDetailError && this.props.myReceiptDetailErrorMessage.message) {
      return (
        <p className="error-message" aria-live="polite">
          {this.props.myReceiptDetailErrorMessage.message} Please try reloading.
        </p>
      )
    }

    return detailList.map((element, index) => {
      return (
        <React.Fragment key={index}>
          <div className="receipt-details-divider" />
          <table>
            <tbody>
              {element.map((detailItem, index) => {
                if (detailItem.LABEL == 'Charge') {
                  detailItem.VALUE = parseFloat(detailItem.VALUE).toFixed(2)
                }
                return (
                  <tr className={'receipt-detail'} key={Math.random() + index}>
                    <td className="receipt-label">{detailItem.LABEL}</td>
                    <td className="receipt-value">{detailItem.VALUE}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <div className="receipt-details-divider" />
        </React.Fragment>
      )
    })
  }

  render() {
    const { myReceiptDetails } = this.props
    return (
      <React.Fragment>
        <div className="receipt-details-list">
          <h5>Receipt Items</h5>
          {this.renderDetailList(myReceiptDetails)}
        </div>
      </React.Fragment>
    )
  }
}

MyReceiptDetails = connect(
  (state, props) => ({
    myReceiptDetails: state.myReceipts.myReceiptDetails,
    myReceiptDetailsLoading: state.myReceipts.myReceiptDetailsLoading,
    myReceiptDetailError: state.myReceipts.myReceiptDetailError,
    myReceiptDetailErrorMessage: state.myReceipts.myReceiptDetailErrorMessage,
  }),
  {
    pullAndSetReceiptDetails,
  }
)(MyReceiptDetails)

export default MyReceiptDetails



// WEBPACK FOOTER //
// ./src/components/MyReceipts/MyReceiptDetails.js